import React from 'react';
import { Nav, Firm, NavButton } from './styles'; 
import { usePresentation } from '@context/presentation';
import { useHistory } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { clientLogout, stopEventStreamUpdates } from '@services';
import { LogoImage } from '../../../styles';
import { generateStorageBlobUrl } from '@utils/generateAssetLinks';
import { BLOB_TYPES, PAGE_URLS, UNAVAILABLE_CS_FIRM } from '@constants';
import { getProfileNameForLogo } from '@utils/profileUtils';
import { clearBrowserStorage, endPresentation } from '@utils/browserStorage';
import { PresentationDispatch } from '@actions/types';

type NavbarProps = {
    dispatch: PresentationDispatch,
    slideId: number
}

export const Navbar: React.FC<NavbarProps> = ({ dispatch, children, slideId }) => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const { client, profile, presentationType, presentationId } = usePresentation();
    const { leadId, firmShortName } = client;

    const mutation = useMutation((leadId: number) => clientLogout(leadId), {
        onSuccess: () => {
            clearBrowserStorage();
            queryClient.clear();
            history.push(PAGE_URLS.CLIENT_LOGIN);
        }
    });

    const logoName = getProfileNameForLogo(firmShortName, profile);
    const logo = generateStorageBlobUrl(BLOB_TYPES.logo, logoName);

    const handleLogout = async () => {
        stopEventStreamUpdates({ presentationType, slideId, presentationId });
        endPresentation(dispatch);
        mutation.mutate(leadId);
    };

    return (
        <Nav>
            <div>
                <LogoImage 
                    view='navbar'
                    src={logo}
                    alt={`${logoName} logo`} />
                { 
                    firmShortName !== UNAVAILABLE_CS_FIRM && 
                        <Firm>
                        <span>|</span>
                        <span>{firmShortName}</span>
                    </Firm>
                }
            </div>
            <div>
                { children }
                <NavButton border={false} onClick={handleLogout}>
                    Logout
                </NavButton>
            </div>
        </Nav>
    );
};

export default Navbar;
